import { createAsyncTypes } from 'utils/ActionCreator'

const PSA_ACTION_NAMESPACE = 'Settings/MalwareDetection/PSA'

export const GET_WIZARD_SCHEMA_ASYNC = createAsyncTypes('GET_WIZARD_SCHEMA', PSA_ACTION_NAMESPACE)
export const GET_PROVIDER_CONFIG_ASYNC = createAsyncTypes(
  'GET_PROVIDER_CONFIG',
  PSA_ACTION_NAMESPACE
)
export const RUN_WIZARD_ACTION_ASYNC = createAsyncTypes('RUN_WIZARD_ACTION', PSA_ACTION_NAMESPACE)
export const SAVE_PSA_INTEGRATION_ASYNC = createAsyncTypes(
  'SAVE_PSA_INTEGRATION',
  PSA_ACTION_NAMESPACE
)
export const GET_PSA_TILE_ASYNC = createAsyncTypes('GET_PSA_TILE', PSA_ACTION_NAMESPACE)
export const DISABLE_PSA_INTEGRATION_ASYNC = createAsyncTypes(
  'DISABLE_PSA_INTEGRATION',
  PSA_ACTION_NAMESPACE
)

export const CLEAR_WIZARD_ACTION = `${PSA_ACTION_NAMESPACE}/CLEAR_WIZARD_ACTION`
export const RESET_PSA_WIZARD_STATE = `${PSA_ACTION_NAMESPACE}/RESET_PSA_WIZARD_STATE`
